import Api2Talk from '../api2talk';

// Item #7 roadmap chatbot JOINT (08/10/2026) — read-only lookup do catálogo de ações nativas.
// Backend: Mexx.Mexx2Talk.Api/Controllers/NativeActionLookupController.cs → GET /api/native-actions
const PATH = '/native-actions';

const getAll = async () => {
  try {
    const response = await Api2Talk.get(PATH);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export { getAll };
